const NAME = 'SENDBIRD';

export const getUnreadCount = (store) => store[NAME].channel.unread.data || 0;
